import React, { useState, useEffect, useRef } from 'react';
// import { fetchAllPromisedData } from '../../../../common/utils/methods/commonMethods/utilityMethod';
// import { endpoint } from '../../../../common/constant';
// import ALoader from '../../../../common/a-loader';
import { Card, CardBody } from 'reactstrap';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import ALoader from 'views/pages/manage/common/a-loader';
// import { getDropdowns } from './utils';
import ListComponent from './ListComponent';
import { endpoint } from '../../../../../manage/common/constant';
import { fetchAllPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { paymentGatewayDropdown } from './constant';
import { processRowList, tabFilledHandler } from '../constant';
import { updateRequest } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { getAuditDetails } from '../common';

const PaymentGateway = ({
    buId,
    selectedTabValue,
    action = 'view',
    setFilled
}) => {

    const [rows, setRows] = useState([]);
    const ref = useRef()
    const [loader, setLoader] = useState(false)
    const [dropdowns, setDropdowns] = useState({})
    const isFirstRender = useRef(true);

    // const fetchCSCMappingData = async () => {
    //     try {
    //         setRows(prev => ({ ...prev, fetching: true }));
    //         const resp = await fetchAllPromisedData(`${endpoint.receiptIndex.getReceiptIndices}/${buId}`, true);
    //         if (resp?.code === 200) {
    //             const data = resp?.data?.map((el, idx) => ({ ...el, srNo: idx + 1 }))
    //             setRows(prev => ({ ...prev, data }));
    //         }
    //     } catch (err) {
    //         console.error(err);
    //     } finally {
    //         setRows(prev => ({ ...prev, fetching: false }));
    //     }
    // }

    const getPaymentList = async (dropdownData = dropdowns) => {
        try {
            setLoader(true)
            const url = `${endpoint.paymentGateway.get}/${buId}`
            const data = await fetchAllPromisedData(url)
            action != 'view' && checkFilled(data)
            setRows(processRowList(data ?? [], dropdownData))
        }
        catch (err) {
            console.log(err)
        }
        finally {
            setLoader(false)
        }
    }



    // useEffect(() => {
    //     buId && selectedTabValue?.key=='paymentGateway' && init()
    // }, [buId,selectedTabValue?.key])
    

useEffect(() => {
  if (isFirstRender.current) {
    isFirstRender.current = false;
    if (buId) init(); 
    return;
  }
  if (buId && selectedTabValue?.key === "paymentGateway") {
    init();
  }
}, [buId, selectedTabValue?.key]);

        const checkFilled = (data) => {
            if (data?.length!=0) {
                tabFilledHandler(setFilled, 'paymentGateway', true)
            }
            else {
                tabFilledHandler(setFilled, 'paymentGateway', false)
            }
        }

    const init = async () => {
        try {
            setLoader(true)
            const dropdown = { gatewayType: paymentGatewayDropdown }
            await getPaymentList(dropdown);
            setDropdowns(dropdown)
        }
        catch (err) {

        }
        finally {
            setLoader(false)
        }
    }

    const createUpdateHandler = async (rowForm) => {
        try {
            setLoader(true);
            const reqObj = updateRequest({
                ...rowForm,
                businessUnitId: buId,
            })
            let url = endpoint.paymentGateway.create;
            let method = 'post';

            if (!rowForm?.isNew) {
                url = `${endpoint.paymentGateway.update}/${reqObj?.id}`;
                method = 'put'
            }
            const resp = await fetchAllPostPromisedData(url, reqObj, method);
            if (resp?.code === 200) {
                getPaymentList()
                successToast('Request completed successfully!!!')
                ref.current.stopEditing();
            }
        } catch (err) {
            console.log(err);
        }
        finally{
            setLoader(false)
        }
    }

    if (selectedTabValue?.id !== 5) return null;

    return (
        <>
            <Card className='ml-0'>
                <CardBody>
                    <div className='d-flex justify-content-between mx-2 my-3'>


                        <div className='large-text color-grey-80'>Payment Gateway</div>

                        {action != 'view' && <AButton
                            variant='primary_filled'
                            onClick={() => ref.current.addNewRow()}
                            size='xs'
                        >
                            + Add Gateway
                        </AButton>}
                    </div>
                    <div style={{ border: '1px solid #E2E2E2' }}>


                        <ListComponent
                            rows={rows}
                            ref={ref}
                            dropdowns={dropdowns}
                            createUpdateHandler={createUpdateHandler}
                            loading={loader}
                            setDropdowns={setDropdowns}
                        />
                    </div>
                    {rows.length > 0 && getAuditDetails(rows[0].updatedBy, rows[0].updatedOn)}
                </CardBody>

            </Card>
        </>
    );
}

export default PaymentGateway;